<div class="b-input__table" style="width: 100%">
    <div class="b-input__table-td">
        <label [for]="id" class="b-input__label" [innerHTML]="label"></label>
        <p-date-picker #datepicker 
            [selectionMode]="selectionMode"
            [placeholder]="effectivePlaceholder"
            [dateFormat]="_dateFormat" [firstDayOfWeek]="firstDayOfWeek"
            [showButtonBar]="showButtonBar" [defaultDate]="pagedate"
            [showOtherMonths]="true" [selectOtherMonths]="true" [required]="required"
            [maxDate]="maxdate" [minDate]="mindate" [disabled]="disabled" [readonlyInput]="readonlyInput"
            [(ngModel)]="value" [showTime]="showTime" 
             (onFocus)="onFocus($event)" (onBlur)="onBlur($event)"
            (onSelect)="onSelect($event)"
            [inputId]="id"
            [autofocus]="false"
            >
            <ng-template pTemplate="header">
                <ng-content select="f-facet[name=header],[facet-header]"></ng-content>
            </ng-template>
            <ng-template pTemplate="footer">
                <ng-content select="f-facet[name=footer],[facet-footer]"></ng-content>
            </ng-template>
        </p-date-picker>
    </div>
    <div class="b-input__button-wrapper">
        <button w-button buttonType="calendar" size="large" (click)="toggleCalendar($event)" type="button"></button>
    </div>
</div>

<f-facet-info [isError]="true" [text]="error">
    <ng-content select="f-facet[name=error],[facet-error]"></ng-content>
</f-facet-info>
<f-facet-info [text]="info">
    <ng-content select="f-facet[name=info],[facet-info]"></ng-content>
</f-facet-info>